export default "__VITE_ASSET__BXjHvZ2$__"